import { render } from "./LogoutModal.vue?vue&type=template&id=b18167ae&ts=true"
import script from "./LogoutModal.vue?vue&type=script&lang=ts"
export * from "./LogoutModal.vue?vue&type=script&lang=ts"

import exportComponent from "/home/bisite/hyperlender/express-server/vue-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__